import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-redux-i18n';
import LocaleNavLink from 'components/LocaleNavLink';
import {
    SERVICE_FREEFLOATING,
    SERVICE_PRICING,
} from 'constants/route';
import StandardContainer from 'components/StandardContainer';
import movingScooter from 'assets/img/p3/scooter_break.png';
import { renderAnimation } from 'helpers/lottie';
import pipeAnimationConfig from 'assets/lottie/web_goshare_pipe.json';
import dotsAnimationConfig from 'assets/lottie/web_goshare_dots.json';
import './go-everywhere.scss';

const DAY_PASS_LINK = 'http://event.ridegoshare.com/goshare-day-pass';

class GoEverywhere extends Component {
    static propTypes = {
        innerRef: PropTypes.shape(),
        run: PropTypes.bool,
    };

    static defaultProps = {
        innerRef: React.createRef(),
        run: false,
    };

    constructor(props) {
        super(props);

        this.elScooter = React.createRef();
        this.elDots = React.createRef();
    }

    componentDidMount() {
        renderAnimation(this.elScooter.current, pipeAnimationConfig);
        renderAnimation(this.elDots.current, dotsAnimationConfig);
    }

    render() {
        const { innerRef, run } = this.props;
        const containerCls = classNames({
            'go-everywhere': true,
            'ride-scooter': run,
        });

        return (
            <StandardContainer innerRef={ innerRef } className={ containerCls } ghostHeader>
                <div className="row row-first">
                    <article className="col description">
                        <Translate className="caption" value="go-everywhere.caption-1" tag="h3" />
                        <Translate className="content" value="go-everywhere.description-1-1" tag="p" />
                        <p className="content withLink">
                            <LocaleNavLink className="link" to={ SERVICE_FREEFLOATING }>
                                <Translate  value="go-everywhere.read-more"/>
                            </LocaleNavLink>
                        </p>
                        <Translate className="content notice" value="go-everywhere.description-1-2" tag="p" />
                    </article>
                    <div ref={ this.elScooter } className="col pipe" />
                </div>
                <div className="row row-day-pass">
                    <div className="col day-pass">
                        <div class="day-pass-image">
                            <div class="day-pass-hand" />
                        </div>
                    </div>
                    <article className="col description">
                        <Translate className="caption" value="go-everywhere.caption-3" tag="h3" />
                        <Translate className="content" value="go-everywhere.description-3-1" tag="p" />
                        <Translate className="content" value="go-everywhere.description-3-2" tag="p" />
                        <p className="content withLink">
                            <a
                                href={ DAY_PASS_LINK }
                                className="link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Translate  value="go-everywhere.read-more"/>
                            </a>
                        </p>
                        <Translate className="content notice" value="go-everywhere.description-3-3" tag="p" />
                    </article>
                </div>
                <div className="row row-second">
                    <div className="col dots" ref={ this.elDots }></div>
                    <article className="col description">
                        <Translate className="caption" value="go-everywhere.caption-2" tag="h3" />
                        <Translate className="content" value="go-everywhere.description-2-1" tag="p" />
                        <p className="content withLink">
                            <LocaleNavLink className="link" to={ SERVICE_PRICING }>
                                <Translate  value="go-everywhere.read-more"/>
                            </LocaleNavLink>
                        </p>
                    </article>
                </div>
                <img
                    src={ movingScooter }
                    className="moving-scooter"
                    alt="Gogoro 電動共享機車,scooter sharing"
                />
            </StandardContainer>
        );
    }
}

export default GoEverywhere;
